import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuX, LuUser, LuLock, LuLogIn, LuCircleAlert, LuEye, LuEyeClosed } from 'react-icons/lu';
import api from '../../api/axios';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!username || !password) {
            setErrorMessage('Por favor, completa todos los campos.');
            return;
        }

        try {
            const response = await api.post('/auth/login', { 
                username, 
                password 
            });

            const data = response.data;

            localStorage.setItem('token', data.token);
            localStorage.setItem('username', data.user.username);
            localStorage.setItem('role', data.user.role);
            localStorage.setItem('userId', data.user.id);
            localStorage.setItem('slug', data.user.slug);

            setUsername('');
            setPassword('');
            setShowPassword(false);
            setErrorMessage('');
            onClose();

            if (data.user.role === 'Administrador') {
                navigate(`/admin/dashboard/${data.user.slug}`);
            } else if (data.user.role === 'Superadministrador') {
                navigate(`/`);
            } else {
                navigate('/');
            }
        } catch (error) {
            console.error('Error en el inicio de sesión:', error);
            if (error.response && error.response.data) {
                setErrorMessage(error.response.data.message || 'Credenciales incorrectas.');
            } else {
                setErrorMessage('Ocurrió un error al conectar con el servidor.');
            }
        }
    };

    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="auth-modal-overlay" onClick={handleOverlayClick}>
            <div className="auth-modal-card">
                <button 
                    className="auth-modal-close-btn" 
                    onClick={onClose}
                    type="button"
                    aria-label="Cerrar modal"
                >
                    <LuX />
                </button>

                <div className="auth-modal-header">
                    <h2 className="auth-modal-title">Acceso Plataforma</h2>
                    <p className="auth-modal-subtitle">Ingresa tus credenciales para continuar</p>
                </div>

                {errorMessage && (
                    <div className="auth-modal-error">
                        <LuCircleAlert className="error-icon" />
                        <span>{errorMessage}</span>
                    </div>
                )}

                <form className="auth-modal-form" onSubmit={handleLogin}>
                    <div className="auth-modal-field">
                        <label className="auth-modal-label">Usuario</label>
                        <div className="auth-modal-input-wrapper">
                            <LuUser className="input-icon" />
                            <input
                                type="text"
                                className="auth-modal-input"
                                placeholder="Nombre de usuario"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className="auth-modal-field">
                        <label className="auth-modal-label">Contraseña</label>
                        <div className="auth-modal-input-wrapper">
                            <LuLock className="input-icon" />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className="auth-modal-input"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="auth-modal-eye-btn"
                                onClick={() => setShowPassword(prev => !prev)}
                                aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                            >
                                {showPassword ? <LuEyeClosed /> : <LuEye />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="auth-modal-submit-btn">
                        <LuLogIn className="btn-icon" /> Iniciar Sesión
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginModal;